import { Component, forwardRef, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR, Validators } from '@angular/forms';
import { IonCol } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import moment, { Moment } from 'moment';
import { TimeUtils } from 'src/smoothr-web-app-core/utils/time-utils';

const SEARCH_INPUT_CONTROL_ACCESSOR = {
	provide: NG_VALUE_ACCESSOR,
	useExisting: forwardRef(() => SelectDateFormcontrolComponent),
	multi: false,
};

@Component({
	selector: 'app-select-date-formcontrol',
	templateUrl: './select-date-formcontrol.component.html',
	styleUrls: ['./select-date-formcontrol.component.scss'],
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => SelectDateFormcontrolComponent),
			multi: true,
		},
	],
})
export class SelectDateFormcontrolComponent implements ControlValueAccessor, OnInit {
	@ViewChild('timeCol', { static: true }) timeCol: IonCol;
	@Input() set slots(slots: Moment[]) {
		this.dates = [];
		this._slots = (slots || []).filter(s => !!s);
		this._slots.forEach(slot => {
			const insertedDate = this.dates.find(date => TimeUtils.isSameDate(date, slot));
			if (!insertedDate) {
				this.dates.push(slot);
			}
		});
		this._slot = this._slots[0];
	}

	onChange: any = () => {};
	onTouched: any = () => {};
	get slots(): Moment[] {
		return this._slots;
	}
	private _slots: Moment[] = [];
	@Input()
	set slot(slot: Moment) {
		// const slotValue = moment(slot)
		console.log('INCOME SLOT');
		this._slot = slot;
		this.onChange(slot);
	}
	get slot(): Moment {
		return this._slot;
	}
	private _slot: Moment;
	dates: Moment[] = [];
	now: moment.Moment;
	maxSlots = 5;
	maxDates = 3;
	TimeUtils = TimeUtils;
	showAll = false;

	constructor(private translate: TranslateService) {}

	ngOnInit(): void {
		this.now = moment();
	}
	writeValue(value: number): void {}

	registerOnChange(fn: any): void {
		this.onChange = fn;
	}

	registerOnTouched(fn: any): void {
		this.onTouched = fn;
	}

	get visibleTimes(): Moment[] {
		const base = this.timesForDate(this.slot).filter(t => !!t);
		return this.showAll ? base : base.slice(0, 10);
	}

	toggleExpanded(): void {
		this.showAll = !this.showAll;
	}

	slotToText(slot: Moment): string {
		if (!slot) {
			return null;
		}
		if (!moment.isMoment(slot)) {
			slot = moment(slot);
		}
		const now = moment();
		const sameDay = TimeUtils.isSameDate(slot, now);
		if (sameDay) {
			return slot.format('HH:mm');
		} else {
			return slot.format('HH:mm / DD.MM.yyyy');
		}
	}
	slotToDateText(slot: Moment): string {
		if (TimeUtils.isSameDate(slot, this.now)) {
			return this.translate.instant('common.today');
		}
		return slot.locale(this.translate.currentLang).format('dd DD.MM.');
	}
	slotToTimeText(slot: Moment): string {
		if (!slot) return this.translate.instant('checkout_modal.first_slot');
		return slot.format('HH:mm');
	}
	timesForDate(selectedDate: Moment): Moment[] {
		const date = selectedDate ?? this.dates[0] ?? null;
		if (!date) {
			return [];
		}
		return this.slots.filter(slot => TimeUtils.isSameDate(slot, date) || (!slot && date === this.dates[0]));
	}
	setDate(date: Moment) {
		this.slot = date;
		this.maxSlots = 5;
		this.showAll = false;
		this.scrollTimeToTop();
	}
	setTime(time: Moment) {
		this.slot = time;
	}
	async scrollTimeToTop() {
		// @ts-ignore
		const el: HTMLDivElement = this.timeCol.el;
		el.scrollTo({
			left: 0,
			top: 0,
		});
	}
	isSame(v1, v2) {
		return moment(v1).isSame(v2);
	}
}
